import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../utilites/snack.service';
import { SettingsService } from '../firestore/settings.service';
import { AuthService } from './auth.service';
import { StripeService } from '../stripe/stripe.service';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private snack: SnackService,
    private settingsService: SettingsService,
    private router: Router,
    private authService: AuthService,
    private stripeService: StripeService,
    private messageService: MessageService
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {


    if (!navigator.onLine) {
      this.messageService.clear();
      this.messageService.add({  severity: 'error', summary: 'Error', detail: 'You are OFFLINE' });
      this.router.navigate(['/offline']);
      return false;
    }

    // se nao logado, faz dormir 1 segundo para authSevice atualizar o user
    if (!this.authService.currentUser) {
      await new Promise(resolve => setTimeout(resolve, 1500));
    }
    const user = await firstValueFrom(this.authService.user$);
    const isLoggedIn = !!user;

    if (!isLoggedIn) {
      // Se não estiver logado, redirecione para o login
      //this.snack.authError();
      this.router.navigate(['/login'], {queryParams: {from: state.url}});
      return false;
    } else {
      //this.userService.setUserId(user.uid);

      // todo mudar isso aqui, nao é lugar para isso
      //this.settingsService.startListenSettingsChange();

      // Agora, verifique o estado da subscrição
      const currentSubscription = await firstValueFrom(this.stripeService.currentSubscription$);
      if (!currentSubscription || (currentSubscription.status !== 'trialing' && currentSubscription.status !== 'active')) {
        this.router.navigate(['/subscription']);
        return false;
      }
    }

    return true;


  }
}


@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  constructor(private router: Router, private authService: AuthService, private messageService: MessageService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {


    if (!navigator.onLine) {
      this.messageService.clear();
      this.messageService.add({  severity: 'error', summary: 'Error', detail: 'You are OFFLINE' });
      this.router.navigate(['/offline']);
      return false;
    }

    // se nao logado, faz dormir 1 segundo para authSevice atualizar o user
    if (!this.authService.currentUser) {
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    const user = await firstValueFrom(this.authService.user$);
    const isLoggedIn = !!user;

    if (!isLoggedIn) {
      // Se não estiver logado, redirecione para o login
      //this.snack.authError();
      this.router.navigate(['/login'], {queryParams: {from: state.url}});
      return false;
    } else {
      return true;
    }

  }
}
